var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path, _g12, _path2, _path3, _path4, _g13, _g14, _g15, _g16, _path5, _path6, _path7, _g17, _g18, _g19, _path8, _path9, _path10, _g20, _g21, _g22, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g23, _g24, _g25, _g26, _g27, _g28, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g29, _g30, _g31, _g32, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g33, _g34, _path50, _g35, _g36, _path51, _g37, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg001TotalBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 683.017,
    height: 180.477,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st12{fill:#fff}.st102{fill:#231f20}.st14396{fill:#eeefef}.st14397{fill:#a97c6d}.st14398{fill:#895a4d}.st14399{fill:#514a3f}.st14400{fill:#3c2415}.st14401{fill:#a6474a}.st14402{fill:#7d3940}.st14403{fill:#414042}.st14404{fill:#5b4c4c}.st14405{fill:#493b3b}.st14406{fill:#6d6e71}.st14407{fill:#f9ddc1}.st14408{fill:#ced0d1}.st14410{fill:#e18a6b}.st14411{fill:#a9533c}.st14412{fill:#cf785d}.st14413{fill:#e9bb6c}.st14414{fill:#e1e1e1}.st14416{fill:#b1624d}.st14417{fill:#b96139}.st14418{fill:#954a2c}.st14420{fill:#8e422b}.st14422{fill:#e3e4e5}.st14423{fill:#b7b9bc}.st14425{fill:#29282b}.st14428{fill:#6b303a}.st14429{fill:#5e5963}.st14430{fill:#ad632e}.st14431{fill:#a05828}.st14432{fill:#8c4d22}.st14433{fill:#c16f38}.st14434{fill:#a67c50}.st14435{fill:#9bb354}.st14436{fill:#d85847}.st14437{fill:#b94239}.st14438{fill:#df736a}.st14439{fill:#8a9e43}.st14440{fill:#928a7b}.st14441{fill:#7c7669}.st14442{fill:#aca494}.st14444{fill:#b98d63}.st14445{fill:#352f27}.st14447{opacity:.3;fill:#414042}.st14449{fill:#e58d63}.st14450{fill:#9b6f44}.st14451{fill:#dda677}.st14453{fill:#594a42}.st14456{fill:#2c2b2d}")), /*#__PURE__*/React.createElement("g", {
    id: "g4547",
    transform: "translate(-158.706 -435.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.996 458.544a9.591 9.591 0 0 1-9.592 9.592 9.591 9.591 0 0 1-9.592-9.592c0-5.297 4.294-9.591 9.592-9.591 5.298 0 9.592 4.295 9.592 9.591z",
    id: "path2081",
    style: {
      fill: "#f4cd1e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556.995 451.061 3.88 15.361a9.578 9.578 0 0 0 4.122-7.877c0-5.297-4.294-9.591-9.592-9.591-5.298 0-9.592 4.294-9.592 9.591 0 .137.005.271.01.407z",
    id: "path2083",
    style: {
      fill: "#f4dc69"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2089"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    d: "M488.154 485.1a5.821 5.821 0 0 0-6.11-7.611 7.24 7.24 0 0 0-13.914-2.411 8.582 8.582 0 0 0-12.984 10.022z",
    id: "path2087"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M488.154 485.1a5.821 5.821 0 0 0-6.11-7.611 7.19 7.19 0 0 0-.682-2.716L459.971 485.1z",
    id: "path2091"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g2101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2097"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    d: "M225.72 547a7.237 7.237 0 0 0-7.596-9.462 9 9 0 0 0-17.299-2.999 10.618 10.618 0 0 0-6.149-1.952c-5.893 0-10.67 4.777-10.67 10.67 0 1.318.24 2.578.676 3.743z",
    id: "path2095"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M225.72 547a7.237 7.237 0 0 0-7.596-9.462 8.95 8.95 0 0 0-.848-3.376L190.683 547z",
    id: "path2099"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g2109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    d: "M181.881 518a4.02 4.02 0 0 0-4.22-5.256 5 5 0 0 0-9.611-1.666 5.928 5.928 0 0 0-8.968 6.923h22.799z",
    id: "path2103"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.881 518a4.02 4.02 0 0 0-4.22-5.256 4.98 4.98 0 0 0-.471-1.876L162.416 518z",
    id: "path2107"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g2115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    d: "M580.633 471.808a10.621 10.621 0 0 1-.434-3.001c0-5.86 4.751-10.612 10.613-10.612 1.662 0 3.234.382 4.634 1.064a8.952 8.952 0 0 1 17.458 3.616 7.198 7.198 0 0 1 8.13 8.932h-40.401z",
    id: "path2111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M580.633 471.808a10.621 10.621 0 0 1-.434-3.001c0-4.125 2.359-7.692 5.797-9.448l25.788 12.449z",
    id: "path2113"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g2121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    d: "M767.602 493a5.968 5.968 0 0 1 6.263-7.802 7.422 7.422 0 0 1 14.265-2.472 8.798 8.798 0 0 1 13.313 10.275h-33.841z",
    id: "path2117"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M767.602 493a5.968 5.968 0 0 1 6.263-7.802c.043-.86.241-1.678.553-2.437L795.626 493z",
    id: "path2119"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g2475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2391"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect2125",
    d: "M424.549 543.783h79.667v25.843h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14398",
    id: "rect2127",
    d: "M424.549 543.783h79.667v1.724h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2129",
    d: "M424.549 569.146h79.667v.498h-79.667z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2131",
    d: "M431.64 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2133",
    d: "M432.177 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2135",
    d: "M434.335 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2137",
    d: "M436.495 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2141",
    d: "M432.177 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2143",
    d: "M434.335 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2145",
    d: "M436.495 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2149",
    d: "M432.177 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2151",
    d: "M434.335 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2153",
    d: "M436.495 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2161",
    d: "M451.449 551.623h7.125v10.32h-7.125z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2163",
    d: "M451.986 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2165",
    d: "M454.145 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2167",
    d: "M456.304 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2171",
    d: "M451.986 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2173",
    d: "M454.145 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2175",
    d: "M456.304 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2179",
    d: "M451.986 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2181",
    d: "M454.145 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2183",
    d: "M456.304 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2191",
    d: "M491.067 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2193",
    d: "M491.605 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2195",
    d: "M493.763 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2197",
    d: "M495.922 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2201",
    d: "M491.605 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2203",
    d: "M493.763 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2205",
    d: "M495.922 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2209",
    d: "M491.605 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2211",
    d: "M493.763 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2213",
    d: "M495.922 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2249"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2221",
    d: "M471.258 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2223",
    d: "M471.796 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2225",
    d: "M473.954 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2227",
    d: "M476.113 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2237"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2231",
    d: "M471.796 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2233",
    d: "M473.954 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2235",
    d: "M476.113 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2239",
    d: "M471.796 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2241",
    d: "M473.954 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2243",
    d: "M476.113 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2301"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2251",
    d: "M458.444 573.656h3.996v10.65h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2253",
    d: "M452.896 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "polygon2255",
    d: "M482.92 585.12v2.766h3.997v-14.23h-3.997v10.649h3.996v.815z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2257",
    d: "M458.444 585.12h3.996v2.766h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2259",
    d: "M447.348 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2261",
    d: "M452.896 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2263",
    d: "M441.848 573.656h4.685v10.65h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2265",
    d: "M441.848 585.12h4.685v2.766h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2267",
    d: "M447.348 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2269",
    d: "M466.323 573.656h4.686v10.65h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2271",
    d: "M477.372 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2273",
    d: "M477.372 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2275",
    d: "M466.323 585.12h4.686v2.766h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2277",
    d: "M471.823 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2279",
    d: "M471.823 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon2281",
    d: "M462.44 599.8v-3.387h-24.476v3.387z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon2283",
    d: "M490.8 596.413h-24.477v3.387H490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M466.323 569.626h-1.942V599.8h1.942v-3.387h20.594v-8.526h-3.997v-2.766h3.996v-.815h-3.996v-10.65h5.939v22.757h1.942V573.656h9.531v-4.029h-34.009zm10.234 14.679h-4.734v-10.65h4.734zm-4.734.815h4.734v2.766h-4.734zm-.814-11.464v10.65h-4.686v-10.65zm-4.686 11.464h4.686v2.766h-4.686zm15.783 2.766h-4.734v-2.766h4.734zm0-3.581h-4.734v-10.65h4.734z",
    id: "path2285"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2287",
    d: "M426.491 599.8v-30.174h-1.942V599.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "polygon2289",
    d: "M504.215 569.626h-1.941v26.787h1.941v-22.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2291",
    d: "M502.274 596.413v-26.787h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2293",
    d: "M462.44 585.12v14.68h1.942v-30.174h-1.942V584.305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M439.906 596.413h22.534v-8.526h-3.996v-2.766h3.996v-.815h-3.996v-10.65h3.996v-4.029h-35.95V599.8h1.942v-26.144h11.473v22.757zm12.175-12.108h-4.733v-10.65h4.733zm-4.733.815h4.733v2.766h-4.733zm-.815-.815h-4.685v-10.65h4.685zm0 .815v2.766h-4.685v-2.766zm11.096 2.766h-4.733v-2.766h4.733zm0-3.581h-4.733v-10.65h4.733z",
    id: "path2295"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2297",
    d: "M439.906 596.413v-22.757h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2299",
    d: "M488.859 596.413v-22.757h-1.942V596.413z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect2303",
    d: "M501.788 545.507h.972v24.138h-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon2305",
    d: "M501.788 545.507h.971l.226-.721v-1.975h-1.423v1.975z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2331"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14404",
    id: "rect2307",
    d: "M422.654 514.036h83.694v29.747h-83.694z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2325"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2309",
    d: "M422.654 516.403h83.456v.375h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2311",
    d: "M422.654 519.923h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2313",
    d: "M422.654 523.441h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2315",
    d: "M422.654 526.961h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2317",
    d: "M422.654 530.481h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2319",
    d: "M422.654 534.001h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2321",
    d: "M422.654 537.521h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2323",
    d: "M422.654 541.04h83.456v.377h-83.456z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2327",
    d: "M505.496 511.967h1.227v31.816h-1.227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2329",
    d: "M422.041 511.967h1.227v31.816h-1.227z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2343"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2333",
    d: "M428.433 592.384h9.531v10.131h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2335",
    d: "M428.433 592.384h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2337",
    d: "M428.433 594.917h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2339",
    d: "M428.433 597.45h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2341",
    d: "M428.433 599.984h9.531v1.103h-9.531z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2355"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect2347",
    d: "M428.433 573.656h9.531v18.729h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect2349",
    d: "M429.162 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2351",
    d: "M436.552 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2353",
    d: "M429.162 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect2357",
    d: "M431.64 577.416h3.093v1.883h-3.093z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2371"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2361",
    d: "M490.8 592.384h9.531v10.131H490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2363",
    d: "M490.8 592.384h9.531v1.105H490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2365",
    d: "M490.8 594.917h9.531v1.105H490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2367",
    d: "M490.8 597.45h9.531v1.105H490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2369",
    d: "M490.8 599.984h9.531v1.103H490.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2383"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect2375",
    d: "M490.8 573.656h9.531v18.729H490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect2377",
    d: "M491.53 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2379",
    d: "M498.92 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2381",
    d: "M491.53 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect2385",
    d: "M493.949 577.416h3.094v1.883h-3.094z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2397"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect2393",
    d: "M460.004 511.591h8.757v9.46h-8.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2395",
    d: "M459.699 510.086h9.368v1.505h-9.368z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2403"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon2399",
    d: "M447.199 534.867v-8.149l2.002-1.105-9.429-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m451.584 526.592-11.222-16.657h.006a.595.595 0 1 0-1.191 0h.006l-11.223 16.657h1.723l.659-.978 9.431-13.996 9.429 13.995.66.979z",
    id: "path2401"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2431"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon2405",
    d: "m439.723 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon2407",
    d: "M446.438 524.9h.761l-7.476-11.411-.525.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2429"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2409",
    d: "M436.208 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2417"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2411",
    d: "M436.746 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2413",
    d: "M438.904 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2415",
    d: "M441.063 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2425"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2419",
    d: "M436.746 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2421",
    d: "M438.904 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2423",
    d: "M441.063 530.317h1.733v2.602h-1.733z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g2469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2439"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon2435",
    d: "M496.42 534.867v-8.149l2.003-1.105-9.43-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m500.805 526.592-11.223-16.657h.006a.595.595 0 0 0-1.191 0h.006l-11.223 16.657h1.723l.658-.978 9.43-13.996 9.43 13.995.659.979z",
    id: "path2437"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2467"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon2441",
    d: "m488.944 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon2443",
    d: "M495.66 524.9h.76l-7.476-11.411-.524.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2465"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2445",
    d: "M485.43 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2453"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2447",
    d: "M485.967 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2449",
    d: "M488.126 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2451",
    d: "M490.285 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2461"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2455",
    d: "M485.967 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2457",
    d: "M488.126 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2459",
    d: "M490.285 530.317h1.733v2.602h-1.733z"
  })))))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g2827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2743"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect2477",
    d: "M339.549 543.783h79.667v25.843h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14398",
    id: "rect2479",
    d: "M339.549 543.783h79.667v1.724h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2481",
    d: "M339.549 569.146h79.667v.498h-79.667z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2511"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2483",
    d: "M346.64 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2491"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2485",
    d: "M347.177 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2487",
    d: "M349.335 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2489",
    d: "M351.495 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2499"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2493",
    d: "M347.177 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2495",
    d: "M349.335 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2497",
    d: "M351.495 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2507"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2501",
    d: "M347.177 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2503",
    d: "M349.335 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2505",
    d: "M351.495 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2541"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2513",
    d: "M366.449 551.623h7.125v10.32h-7.125z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2521"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2515",
    d: "M366.986 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2517",
    d: "M369.145 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2519",
    d: "M371.304 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2529"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2523",
    d: "M366.986 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2525",
    d: "M369.145 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2527",
    d: "M371.304 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2537"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2531",
    d: "M366.986 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2533",
    d: "M369.145 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2535",
    d: "M371.304 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2571"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2543",
    d: "M406.067 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2551"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2545",
    d: "M406.605 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2547",
    d: "M408.763 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2549",
    d: "M410.922 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2559"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2553",
    d: "M406.605 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2555",
    d: "M408.763 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2557",
    d: "M410.922 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2567"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2561",
    d: "M406.605 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2563",
    d: "M408.763 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2565",
    d: "M410.922 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2601"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2573",
    d: "M386.258 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2581"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2575",
    d: "M386.796 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2577",
    d: "M388.954 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2579",
    d: "M391.113 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2589"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2583",
    d: "M386.796 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2585",
    d: "M388.954 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2587",
    d: "M391.113 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2597"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2591",
    d: "M386.796 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2593",
    d: "M388.954 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2595",
    d: "M391.113 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2653"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2603",
    d: "M373.444 573.656h3.996v10.65h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2605",
    d: "M367.896 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "polygon2607",
    d: "M397.92 585.12v2.766h3.997v-14.23h-3.997v10.649h3.996v.815z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2609",
    d: "M373.444 585.12h3.996v2.766h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2611",
    d: "M362.348 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2613",
    d: "M367.896 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2615",
    d: "M356.848 573.656h4.685v10.65h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2617",
    d: "M356.848 585.12h4.685v2.766h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2619",
    d: "M362.348 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2621",
    d: "M381.323 573.656h4.686v10.65h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2623",
    d: "M392.372 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2625",
    d: "M392.372 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2627",
    d: "M381.323 585.12h4.686v2.766h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2629",
    d: "M386.823 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2631",
    d: "M386.823 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon2633",
    d: "M377.44 599.8v-3.387h-24.476v3.387z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon2635",
    d: "M405.8 596.413h-24.477v3.387H405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M381.323 569.626h-1.942V599.8h1.942v-3.387h20.594v-8.526h-3.997v-2.766h3.996v-.815h-3.996v-10.65h5.939v22.757h1.942V573.656h9.531v-4.029h-34.009zm10.234 14.679h-4.734v-10.65h4.734zm-4.734.815h4.734v2.766h-4.734zm-.814-11.464v10.65h-4.686v-10.65zm-4.686 11.464h4.686v2.766h-4.686zm15.783 2.766h-4.734v-2.766h4.734zm0-3.581h-4.734v-10.65h4.734z",
    id: "path2637"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2639",
    d: "M341.491 599.8v-30.174h-1.942V599.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "polygon2641",
    d: "M419.215 569.626h-1.941v26.787h1.941v-22.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2643",
    d: "M417.274 596.413v-26.787h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2645",
    d: "M377.44 585.12v14.68h1.942v-30.174h-1.942V584.305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M354.906 596.413h22.534v-8.526h-3.996v-2.766h3.996v-.815h-3.996v-10.65h3.996v-4.029h-35.95V599.8h1.942v-26.144h11.473v22.757zm12.175-12.108h-4.733v-10.65h4.733zm-4.733.815h4.733v2.766h-4.733zm-.815-.815h-4.685v-10.65h4.685zm0 .815v2.766h-4.685v-2.766zm11.096 2.766h-4.733v-2.766h4.733zm0-3.581h-4.733v-10.65h4.733z",
    id: "path2647"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2649",
    d: "M354.906 596.413v-22.757h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2651",
    d: "M403.859 596.413v-22.757h-1.942V596.413z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect2655",
    d: "M416.788 545.507h.972v24.138h-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon2657",
    d: "M416.788 545.507h.971l.226-.721v-1.975h-1.423v1.975z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2683"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14404",
    id: "rect2659",
    d: "M337.654 514.036h83.694v29.747h-83.694z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2677"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2661",
    d: "M337.654 516.403h83.456v.375h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2663",
    d: "M337.654 519.923h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2665",
    d: "M337.654 523.441h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2667",
    d: "M337.654 526.961h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2669",
    d: "M337.654 530.481h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2671",
    d: "M337.654 534.001h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2673",
    d: "M337.654 537.521h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect2675",
    d: "M337.654 541.04h83.456v.377h-83.456z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2679",
    d: "M420.496 511.967h1.227v31.816h-1.227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2681",
    d: "M337.041 511.967h1.227v31.816h-1.227z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2695"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2685",
    d: "M343.433 592.384h9.531v10.131h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2687",
    d: "M343.433 592.384h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2689",
    d: "M343.433 594.917h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2691",
    d: "M343.433 597.45h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2693",
    d: "M343.433 599.984h9.531v1.103h-9.531z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2707"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect2699",
    d: "M343.433 573.656h9.531v18.729h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect2701",
    d: "M344.162 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2703",
    d: "M351.552 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2705",
    d: "M344.162 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect2709",
    d: "M346.64 577.416h3.093v1.883h-3.093z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2723"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2713",
    d: "M405.8 592.384h9.531v10.131H405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2715",
    d: "M405.8 592.384h9.531v1.105H405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2717",
    d: "M405.8 594.917h9.531v1.105H405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2719",
    d: "M405.8 597.45h9.531v1.105H405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect2721",
    d: "M405.8 599.984h9.531v1.103H405.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2735"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect2727",
    d: "M405.8 573.656h9.531v18.729H405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect2729",
    d: "M406.53 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2731",
    d: "M413.92 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect2733",
    d: "M406.53 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect2737",
    d: "M408.949 577.416h3.094v1.883h-3.094z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2749"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect2745",
    d: "M375.004 511.591h8.757v9.46h-8.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2747",
    d: "M374.699 510.086h9.368v1.505h-9.368z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2755"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon2751",
    d: "M362.199 534.867v-8.149l2.002-1.105-9.429-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m366.584 526.592-11.222-16.657h.006a.595.595 0 1 0-1.191 0h.006l-11.223 16.657h1.723l.659-.978 9.431-13.996 9.429 13.995.66.979z",
    id: "path2753"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2783"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon2757",
    d: "m354.723 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon2759",
    d: "M361.438 524.9h.761l-7.476-11.411-.525.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2781"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2761",
    d: "M351.208 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2769"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2763",
    d: "M351.746 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2765",
    d: "M353.904 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2767",
    d: "M356.063 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2777"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2771",
    d: "M351.746 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2773",
    d: "M353.904 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2775",
    d: "M356.063 530.317h1.733v2.602h-1.733z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g2821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2791"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon2787",
    d: "M411.42 534.867v-8.149l2.003-1.105-9.43-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m415.805 526.592-11.223-16.657h.006a.595.595 0 0 0-1.191 0h.006l-11.223 16.657h1.723l.658-.978 9.43-13.996 9.43 13.995.659.979z",
    id: "path2789"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2819"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon2793",
    d: "m403.944 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon2795",
    d: "M410.66 524.9h.76l-7.476-11.411-.524.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2817"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2797",
    d: "M400.43 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2805"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2799",
    d: "M400.967 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2801",
    d: "M403.126 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2803",
    d: "M405.285 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2813"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2807",
    d: "M400.967 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2809",
    d: "M403.126 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2811",
    d: "M405.285 530.317h1.733v2.602h-1.733z"
  })))))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g3179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3095"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect2829",
    d: "M255.549 543.783h79.667v25.843h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14398",
    id: "rect2831",
    d: "M255.549 543.783h79.667v1.724h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2833",
    d: "M255.549 569.146h79.667v.498h-79.667z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2863"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2835",
    d: "M262.64 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2843"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2837",
    d: "M263.177 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2839",
    d: "M265.335 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2841",
    d: "M267.495 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2851"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2845",
    d: "M263.177 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2847",
    d: "M265.335 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2849",
    d: "M267.495 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2859"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2853",
    d: "M263.177 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2855",
    d: "M265.335 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2857",
    d: "M267.495 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2893"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2865",
    d: "M282.449 551.623h7.125v10.32h-7.125z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2873"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2867",
    d: "M282.986 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2869",
    d: "M285.145 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2871",
    d: "M287.304 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2881"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2875",
    d: "M282.986 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2877",
    d: "M285.145 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2879",
    d: "M287.304 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2889"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2883",
    d: "M282.986 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2885",
    d: "M285.145 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2887",
    d: "M287.304 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2923"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2895",
    d: "M322.067 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2903"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2897",
    d: "M322.605 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2899",
    d: "M324.763 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2901",
    d: "M326.922 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2911"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2905",
    d: "M322.605 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2907",
    d: "M324.763 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2909",
    d: "M326.922 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2919"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2913",
    d: "M322.605 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2915",
    d: "M324.763 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2917",
    d: "M326.922 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2953"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect2925",
    d: "M302.258 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2933"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2927",
    d: "M302.796 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2929",
    d: "M304.954 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2931",
    d: "M307.113 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2941"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2935",
    d: "M302.796 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2937",
    d: "M304.954 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2939",
    d: "M307.113 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2949"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2943",
    d: "M302.796 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2945",
    d: "M304.954 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect2947",
    d: "M307.113 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3005"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2955",
    d: "M289.444 573.656h3.996v10.65h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2957",
    d: "M283.896 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "polygon2959",
    d: "M313.92 585.12v2.766h3.997v-14.23h-3.997v10.649h3.996v.815z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2961",
    d: "M289.444 585.12h3.996v2.766h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2963",
    d: "M278.348 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2965",
    d: "M283.896 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2967",
    d: "M272.848 573.656h4.685v10.65h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2969",
    d: "M272.848 585.12h4.685v2.766h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2971",
    d: "M278.348 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2973",
    d: "M297.323 573.656h4.686v10.65h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2975",
    d: "M308.372 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2977",
    d: "M308.372 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2979",
    d: "M297.323 585.12h4.686v2.766h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2981",
    d: "M302.823 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect2983",
    d: "M302.823 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon2985",
    d: "M293.44 599.8v-3.387h-24.476v3.387z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon2987",
    d: "M321.8 596.413h-24.477v3.387H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M297.323 569.626h-1.942V599.8h1.942v-3.387h20.594v-8.526h-3.997v-2.766h3.996v-.815h-3.996v-10.65h5.939v22.757h1.942V573.656h9.531v-4.029h-34.009zm10.234 14.679h-4.734v-10.65h4.734zm-4.734.815h4.734v2.766h-4.734zm-.814-11.464v10.65h-4.686v-10.65zm-4.686 11.464h4.686v2.766h-4.686zm15.783 2.766h-4.734v-2.766h4.734zm0-3.581h-4.734v-10.65h4.734z",
    id: "path2989"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2991",
    d: "M257.491 599.8v-30.174h-1.942V599.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "polygon2993",
    d: "M335.215 569.626h-1.941v26.787h1.941v-22.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2995",
    d: "M333.274 596.413v-26.787h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon2997",
    d: "M293.44 585.12v14.68h1.942v-30.174h-1.942V584.305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M270.906 596.413h22.534v-8.526h-3.996v-2.766h3.996v-.815h-3.996v-10.65h3.996v-4.029h-35.95V599.8h1.942v-26.144h11.473v22.757zm12.175-12.108h-4.733v-10.65h4.733zm-4.733.815h4.733v2.766h-4.733zm-.815-.815h-4.685v-10.65h4.685zm0 .815v2.766h-4.685v-2.766zm11.096 2.766h-4.733v-2.766h4.733zm0-3.581h-4.733v-10.65h4.733z",
    id: "path2999"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3001",
    d: "M270.906 596.413v-22.757h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3003",
    d: "M319.859 596.413v-22.757h-1.942V596.413z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect3007",
    d: "M332.788 545.507h.972v24.138h-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon3009",
    d: "M332.788 545.507h.971l.226-.721v-1.975h-1.423v1.975z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3035"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14404",
    id: "rect3011",
    d: "M253.654 514.036h83.694v29.747h-83.694z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3029"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3013",
    d: "M253.654 516.403h83.456v.375h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3015",
    d: "M253.654 519.923h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3017",
    d: "M253.654 523.441h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3019",
    d: "M253.654 526.961h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3021",
    d: "M253.654 530.481h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3023",
    d: "M253.654 534.001h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3025",
    d: "M253.654 537.521h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3027",
    d: "M253.654 541.04h83.456v.377h-83.456z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3031",
    d: "M336.496 511.967h1.227v31.816h-1.227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3033",
    d: "M253.041 511.967h1.227v31.816h-1.227z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3047"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3037",
    d: "M259.433 592.384h9.531v10.131h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3039",
    d: "M259.433 592.384h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3041",
    d: "M259.433 594.917h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3043",
    d: "M259.433 597.45h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3045",
    d: "M259.433 599.984h9.531v1.103h-9.531z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3059"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect3051",
    d: "M259.433 573.656h9.531v18.729h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect3053",
    d: "M260.162 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3055",
    d: "M267.552 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3057",
    d: "M260.162 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect3061",
    d: "M262.64 577.416h3.093v1.883h-3.093z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3075"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3065",
    d: "M321.8 592.384h9.531v10.131H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3067",
    d: "M321.8 592.384h9.531v1.105H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3069",
    d: "M321.8 594.917h9.531v1.105H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3071",
    d: "M321.8 597.45h9.531v1.105H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3073",
    d: "M321.8 599.984h9.531v1.103H321.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3087"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect3079",
    d: "M321.8 573.656h9.531v18.729H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect3081",
    d: "M322.53 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3083",
    d: "M329.92 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3085",
    d: "M322.53 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect3089",
    d: "M324.949 577.416h3.094v1.883h-3.094z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect3097",
    d: "M291.004 511.591h8.757v9.46h-8.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3099",
    d: "M290.699 510.086h9.368v1.505h-9.368z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon3103",
    d: "M278.199 534.867v-8.149l2.002-1.105-9.429-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m282.584 526.592-11.222-16.657h.006a.595.595 0 1 0-1.191 0h.006l-11.223 16.657h1.723l.659-.978 9.431-13.996 9.429 13.995.66.979z",
    id: "path3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon3109",
    d: "m270.723 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon3111",
    d: "M277.438 524.9h.761l-7.476-11.411-.525.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3113",
    d: "M267.208 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3115",
    d: "M267.746 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3117",
    d: "M269.904 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3119",
    d: "M272.063 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3123",
    d: "M267.746 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3125",
    d: "M269.904 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3127",
    d: "M272.063 530.317h1.733v2.602h-1.733z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g3173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon3139",
    d: "M327.42 534.867v-8.149l2.003-1.105-9.43-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m331.805 526.592-11.223-16.657h.006a.595.595 0 0 0-1.191 0h.006l-11.223 16.657h1.723l.658-.978 9.43-13.996 9.43 13.995.659.979z",
    id: "path3141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon3145",
    d: "m319.944 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon3147",
    d: "M326.66 524.9h.76l-7.476-11.411-.524.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3149",
    d: "M316.43 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3151",
    d: "M316.967 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3153",
    d: "M319.126 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3155",
    d: "M321.285 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3159",
    d: "M316.967 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3161",
    d: "M319.126 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3163",
    d: "M321.285 530.317h1.733v2.602h-1.733z"
  })))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g3531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3447"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect3181",
    d: "M759.549 543.783h79.667v25.843h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14398",
    id: "rect3183",
    d: "M759.549 543.783h79.667v1.724h-79.667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3185",
    d: "M759.549 569.146h79.667v.498h-79.667z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3187",
    d: "M766.64 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3189",
    d: "M767.177 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3191",
    d: "M769.335 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3193",
    d: "M771.495 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3197",
    d: "M767.177 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3199",
    d: "M769.335 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3201",
    d: "M771.495 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3205",
    d: "M767.177 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3207",
    d: "M769.335 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3209",
    d: "M771.495 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3217",
    d: "M786.449 551.623h7.125v10.32h-7.125z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3225"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3219",
    d: "M786.986 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3221",
    d: "M789.145 552.208h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3223",
    d: "M791.304 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3227",
    d: "M786.986 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3229",
    d: "M789.145 555.482h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3231",
    d: "M791.304 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3235",
    d: "M786.986 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3237",
    d: "M789.145 558.756h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3239",
    d: "M791.304 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3275"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3247",
    d: "M826.067 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3255"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3249",
    d: "M826.605 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3251",
    d: "M828.763 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3253",
    d: "M830.922 552.208h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3257",
    d: "M826.605 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3259",
    d: "M828.763 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3261",
    d: "M830.922 555.482h1.733v2.602h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3271"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3265",
    d: "M826.605 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3267",
    d: "M828.763 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3269",
    d: "M830.922 558.756h1.733v2.601h-1.733z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3305"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3277",
    d: "M806.258 551.623h7.126v10.32h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3279",
    d: "M806.796 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3281",
    d: "M808.954 552.208h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3283",
    d: "M811.113 552.208h1.732v2.601h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3293"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3287",
    d: "M806.796 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3289",
    d: "M808.954 555.482h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3291",
    d: "M811.113 555.482h1.732v2.602h-1.732z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3301"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3295",
    d: "M806.796 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3297",
    d: "M808.954 558.756h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3299",
    d: "M811.113 558.756h1.732v2.601h-1.732z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3357"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3307",
    d: "M793.444 573.656h3.996v10.65h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3309",
    d: "M787.896 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "polygon3311",
    d: "M817.92 585.12v2.766h3.997v-14.23h-3.997v10.649h3.996v.815z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3313",
    d: "M793.444 585.12h3.996v2.766h-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3315",
    d: "M782.348 573.656h4.733v10.65h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3317",
    d: "M787.896 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3319",
    d: "M776.848 573.656h4.685v10.65h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3321",
    d: "M776.848 585.12h4.685v2.766h-4.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3323",
    d: "M782.348 585.12h4.733v2.766h-4.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3325",
    d: "M801.323 573.656h4.686v10.65h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3327",
    d: "M812.372 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3329",
    d: "M812.372 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3331",
    d: "M801.323 585.12h4.686v2.766h-4.686z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3333",
    d: "M806.823 585.12h4.734v2.766h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14400",
    id: "rect3335",
    d: "M806.823 573.656h4.734v10.65h-4.734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon3337",
    d: "M797.44 599.8v-3.387h-24.476v3.387z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "polygon3339",
    d: "M825.8 596.413h-24.477v3.387H825.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M801.323 569.626h-1.942V599.8h1.942v-3.387h20.594v-8.526h-3.997v-2.766h3.996v-.815h-3.996v-10.65h5.939v22.757h1.942V573.656h9.531v-4.029h-34.009zm10.234 14.679h-4.734v-10.65h4.734zm-4.734.815h4.734v2.766h-4.734zm-.814-11.464v10.65h-4.686v-10.65zm-4.686 11.464h4.686v2.766h-4.686zm15.783 2.766h-4.734v-2.766h4.734zm0-3.581h-4.734v-10.65h4.734z",
    id: "path3341"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3343",
    d: "M761.491 599.8v-30.174h-1.942V599.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "polygon3345",
    d: "M839.215 569.626h-1.941v26.787h1.941v-22.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3347",
    d: "M837.274 596.413v-26.787h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3349",
    d: "M797.44 585.12v14.68h1.942v-30.174h-1.942V584.305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "M774.906 596.413h22.534v-8.526h-3.996v-2.766h3.996v-.815h-3.996v-10.65h3.996v-4.029h-35.949V599.8h1.942v-26.144h11.473zm12.175-12.108h-4.733v-10.65h4.733zm-4.733.815h4.733v2.766h-4.733zm-.815-.815h-4.685v-10.65h4.685zm0 .815v2.766h-4.685v-2.766zm11.096 2.766h-4.733v-2.766h4.733zm0-3.581h-4.733v-10.65h4.733z",
    id: "path3351"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3353",
    d: "M774.906 596.413v-22.757h-1.942V596.413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14402",
    id: "polygon3355",
    d: "M823.859 596.413v-22.757h-1.942V596.413z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect3359",
    d: "M836.788 545.507h.972v24.138h-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon3361",
    d: "M836.788 545.507h.971l.226-.721v-1.975h-1.423v1.975z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3387"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14404",
    id: "rect3363",
    d: "M757.654 514.036h83.694v29.747h-83.694z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3381"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3365",
    d: "M757.654 516.403h83.456v.375h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3367",
    d: "M757.654 519.923h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3369",
    d: "M757.654 523.441h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3371",
    d: "M757.654 526.961h83.456v.377h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3373",
    d: "M757.654 530.481h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3375",
    d: "M757.654 534.001h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3377",
    d: "M757.654 537.521h83.456v.376h-83.456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14405",
    id: "rect3379",
    d: "M757.654 541.04h83.456v.377h-83.456z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3383",
    d: "M840.496 511.967h1.227v31.816h-1.227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3385",
    d: "M757.041 511.967h1.227v31.816h-1.227z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3399"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3389",
    d: "M763.433 592.384h9.531v10.131h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3391",
    d: "M763.433 592.384h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3393",
    d: "M763.433 594.917h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3395",
    d: "M763.433 597.45h9.531v1.105h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3397",
    d: "M763.433 599.984h9.531v1.103h-9.531z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3411"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect3403",
    d: "M763.433 573.656h9.531v18.729h-9.531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect3405",
    d: "M764.162 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3407",
    d: "M771.552 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3409",
    d: "M764.162 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect3413",
    d: "M766.64 577.416h3.093v1.883h-3.093z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3427"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3417",
    d: "M825.8 592.384h9.531v10.131H825.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3419",
    d: "M825.8 592.384h9.531v1.105H825.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3421",
    d: "M825.8 594.917h9.531v1.105H825.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3423",
    d: "M825.8 597.45h9.531v1.105H825.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect3425",
    d: "M825.8 599.984h9.531v1.103H825.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3439"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect3431",
    d: "M825.8 573.656h9.531v18.729H825.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect3433",
    d: "M826.53 574.49h8.071v17.895h-8.071z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3435",
    d: "M833.92 574.49h.682v17.895h-.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    id: "rect3437",
    d: "M826.53 574.49h7.389v.694h-7.389z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect3441",
    d: "M828.949 577.416h3.094v1.883h-3.094z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3453"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14397",
    id: "rect3449",
    d: "M795.004 511.591h8.757v9.46h-8.757z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3451",
    d: "M794.698 510.086h9.368v1.505h-9.368z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3459"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon3455",
    d: "M782.199 534.867v-8.149l2.002-1.105-9.429-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m786.584 526.592-11.222-16.657h.006a.595.595 0 1 0-1.191 0h.006l-11.223 16.657h1.723l.659-.978 9.431-13.996 9.429 13.995.66.979z",
    id: "path3457"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3487"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon3461",
    d: "m774.723 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon3463",
    d: "M781.438 524.9h.761l-7.476-11.411-.525.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3485"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3465",
    d: "M771.208 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3473"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3467",
    d: "M771.746 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3469",
    d: "M773.904 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3471",
    d: "M776.063 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3481"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3475",
    d: "M771.746 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3477",
    d: "M773.904 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3479",
    d: "M776.063 530.317h1.733v2.602h-1.733z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g3525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3495"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon3491",
    d: "M831.42 534.867v-8.149l2.003-1.105-9.43-13.995-9.431 13.996 2 1.104v8.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    d: "m835.805 526.592-11.223-16.657h.006a.595.595 0 0 0-1.191 0h.006l-11.223 16.657h1.723l.658-.978 9.43-13.996 9.43 13.995.659.979z",
    id: "path3493"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3523"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "polygon3497",
    d: "m823.944 513.489-7.476 11.411h14.952z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14408",
    id: "polygon3499",
    d: "M830.66 524.9h.76l-7.476-11.411-.524.801z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3521"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3501",
    d: "M820.43 526.458h7.126v7.161h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3509"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3503",
    d: "M820.967 527.044h1.732v2.601h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3505",
    d: "M823.126 527.044h1.733v2.601h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3507",
    d: "M825.285 527.044h1.733v2.601h-1.733z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3517"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3511",
    d: "M820.967 530.317h1.732v2.602h-1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3513",
    d: "M823.126 530.317h1.733v2.602h-1.733z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3515",
    d: "M825.285 530.317h1.733v2.602h-1.733z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g4119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon3533",
    style: {
      fill: "#eeb154"
    },
    d: "m661.814 533.182-30.783-16.792h-41.518l-30.752 16.792z"
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g3555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3541"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect3535",
    d: "M590.927 502.031h5.957v12.808h-5.957z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3537",
    d: "M590.927 502.031h5.957v.835h-5.957z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect3539",
    d: "M590.478 499.139h6.853v2.892h-6.853z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3549"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect3543",
    d: "M623.662 502.031h5.957v12.808h-5.957z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3545",
    d: "M623.662 502.031h5.957v.835h-5.957z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect3547",
    d: "M623.214 499.139h6.852v2.892h-6.852z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect3553",
    d: "M589.683 514.84h41.178v1.583h-41.178z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4117"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g3695"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14412",
    id: "polygon3557",
    d: "M636.617 588.308h23.739v-52.533h-25.834v50.843h2.095z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14412",
    id: "rect3559",
    d: "M636.617 590.299h26.818v7.061h-26.818z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect3561",
    d: "M636.617 588.308h26.818v1.17h-26.818z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3563",
    d: "M636.617 589.478h26.818v.821h-26.818z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect3565",
    d: "M634.522 561.025h26.818v1.17h-26.818z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3567",
    d: "M634.522 562.195h25.834v.821h-25.834z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon3569",
    d: "M661.814 533.182h-27.292v1.401h25.834z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3599"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3571",
    d: "M637.188 541.232h7.554v10.94h-7.554z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3579"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3573",
    d: "M642.335 541.853h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3575",
    d: "M640.047 541.853h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3577",
    d: "M637.758 541.853h1.836v2.757h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3587"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3581",
    d: "M642.335 545.323h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3583",
    d: "M640.047 545.323h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3585",
    d: "M637.758 545.323h1.836v2.759h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3595"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3589",
    d: "M642.335 548.794h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3591",
    d: "M640.047 548.794h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3593",
    d: "M637.758 548.794h1.836v2.759h-1.836z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3629"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3601",
    d: "M649.441 541.232h7.555v10.94h-7.555z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3609"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3603",
    d: "M654.589 541.853h1.838v2.757h-1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3605",
    d: "M652.301 541.853h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3607",
    d: "M650.012 541.853h1.836v2.757h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3617"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3611",
    d: "M654.589 545.323h1.838v2.759h-1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3613",
    d: "M652.301 545.323h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3615",
    d: "M650.012 545.323h1.836v2.759h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3625"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3619",
    d: "M654.589 548.794h1.838v2.759h-1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3621",
    d: "M652.301 548.794h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3623",
    d: "M650.012 548.794h1.836v2.759h-1.836z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3659"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3631",
    d: "M637.188 567.473h7.554v10.941h-7.554z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3639"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3633",
    d: "M642.335 568.093h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3635",
    d: "M640.047 568.093h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3637",
    d: "M637.758 568.093h1.836v2.758h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3647"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3641",
    d: "M642.335 571.564h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3643",
    d: "M640.047 571.564h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3645",
    d: "M637.758 571.564h1.836v2.757h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3655"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3649",
    d: "M642.335 575.035h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3651",
    d: "M640.047 575.035h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3653",
    d: "M637.758 575.035h1.836v2.759h-1.836z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3689"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3661",
    d: "M649.441 567.473h7.555v10.941h-7.555z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3669"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3663",
    d: "M654.589 568.093h1.838v2.758h-1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3665",
    d: "M652.301 568.093h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3667",
    d: "M650.012 568.093h1.836v2.758h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3677"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3671",
    d: "M654.589 571.564h1.838v2.757h-1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3673",
    d: "M652.301 571.564h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3675",
    d: "M650.012 571.564h1.836v2.757h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3685"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3679",
    d: "M654.589 575.035h1.838v2.759h-1.838z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3681",
    d: "M652.301 575.035h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3683",
    d: "M650.012 575.035h1.836v2.759h-1.836z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st14414",
    id: "rect3691",
    d: "M634.522 534.583h25.834v1.192h-25.834z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3693",
    d: "M634.522 535.775h25.834v.834h-25.834z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st14412",
    id: "polygon3697",
    d: "M583.927 588.308h-23.708v-52.533h25.834v50.843h-2.126z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect3699",
    style: {
      fill: "#b95d4a"
    },
    d: "M584.441 535.775h1.613v50.842h-1.613z"
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g3707"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14412",
    id: "rect3701",
    d: "M557.109 590.299h26.818v7.061h-26.818z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect3703",
    d: "M557.109 588.308h26.818v1.17h-26.818z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3705",
    d: "M557.109 589.478h26.818v.821h-26.818z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect3709",
    d: "M559.235 561.025h26.818v1.17h-26.818z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3711",
    d: "M560.219 562.195h25.834v.821h-25.834z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon3713",
    d: "M558.761 533.182h27.292v1.401h-25.834z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g3743"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3715",
    d: "M575.667 541.232h7.555v10.94h-7.555z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3723"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3717",
    d: "M576.237 541.853h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3719",
    d: "M578.525 541.853h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3721",
    d: "M580.814 541.853h1.837v2.757h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3731"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3725",
    d: "M576.237 545.323h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3727",
    d: "M578.525 545.323h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3729",
    d: "M580.814 545.323h1.837v2.759h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3739"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3733",
    d: "M576.237 548.794h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3735",
    d: "M578.525 548.794h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3737",
    d: "M580.814 548.794h1.837v2.759h-1.837z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g3773"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3745",
    d: "M563.412 541.232h7.556v10.94h-7.556z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3753"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3747",
    d: "M563.982 541.853h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3749",
    d: "M566.271 541.853h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3751",
    d: "M568.56 541.853h1.838v2.757h-1.838z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3761"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3755",
    d: "M563.982 545.323h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3757",
    d: "M566.271 545.323h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3759",
    d: "M568.56 545.323h1.838v2.759h-1.838z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3769"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3763",
    d: "M563.982 548.794h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3765",
    d: "M566.271 548.794h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3767",
    d: "M568.56 548.794h1.838v2.759h-1.838z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g3803"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3775",
    d: "M575.667 567.473h7.555v10.941h-7.555z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3783"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3777",
    d: "M576.237 568.093h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3779",
    d: "M578.525 568.093h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3781",
    d: "M580.814 568.093h1.837v2.758h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3791"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3785",
    d: "M576.237 571.564h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3787",
    d: "M578.525 571.564h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3789",
    d: "M580.814 571.564h1.837v2.757h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3799"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3793",
    d: "M576.237 575.035h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3795",
    d: "M578.525 575.035h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3797",
    d: "M580.814 575.035h1.837v2.759h-1.837z"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g3833"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3805",
    d: "M563.412 567.473h7.556v10.941h-7.556z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3813"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3807",
    d: "M563.982 568.093h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3809",
    d: "M566.271 568.093h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3811",
    d: "M568.56 568.093h1.838v2.758h-1.838z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3821"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3815",
    d: "M563.982 571.564h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3817",
    d: "M566.271 571.564h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3819",
    d: "M568.56 571.564h1.838v2.757h-1.838z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3829"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3823",
    d: "M563.982 575.035h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3825",
    d: "M566.271 575.035h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3827",
    d: "M568.56 575.035h1.838v2.759h-1.838z"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14414",
    id: "rect3835",
    d: "M560.219 534.583h25.834v1.192h-25.834z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st14411",
    id: "rect3837",
    d: "M560.219 535.775h25.834v.834h-25.834z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4115"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect3839",
    d: "M586.053 538.002h48.478v48.615h-48.478z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g3845"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14416",
    id: "rect3841",
    d: "M586.053 560.801h48.478v.895h-48.478z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect3843",
    d: "M585.285 559.631h50.075v1.17h-50.075z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g3937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3875"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3847",
    d: "M591.01 540.266h7.555v10.941h-7.555z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3855"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3849",
    d: "M596.159 540.887h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3851",
    d: "M593.87 540.887h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3853",
    d: "M591.58 540.887h1.836v2.758h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3863"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3857",
    d: "M596.159 544.357h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3859",
    d: "M593.87 544.357h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3861",
    d: "M591.58 544.357h1.836v2.758h-1.836z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3871"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3865",
    d: "M596.159 547.829h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3867",
    d: "M593.87 547.829h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3869",
    d: "M591.58 547.829h1.836v2.758h-1.836z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3905"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3877",
    d: "M606.536 540.266h7.554v10.941h-7.554z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3885"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3879",
    d: "M611.682 540.887h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3881",
    d: "M609.395 540.887h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3883",
    d: "M607.106 540.887h1.837v2.758h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3893"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3887",
    d: "M611.682 544.357h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3889",
    d: "M609.395 544.357h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3891",
    d: "M607.106 544.357h1.837v2.758h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3901"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3895",
    d: "M611.682 547.829h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3897",
    d: "M609.395 547.829h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3899",
    d: "M607.106 547.829h1.837v2.758h-1.837z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3935"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3907",
    d: "M622.06 540.266h7.554v10.941h-7.554z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3915"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3909",
    d: "M627.209 540.887h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3911",
    d: "M624.919 540.887h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3913",
    d: "M622.629 540.887h1.838v2.758h-1.838z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3923"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3917",
    d: "M627.209 544.357h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3919",
    d: "M624.919 544.357h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3921",
    d: "M622.629 544.357h1.838v2.758h-1.838z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3931"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3925",
    d: "M627.209 547.829h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3927",
    d: "M624.919 547.829h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3929",
    d: "M622.629 547.829h1.838v2.758h-1.838z"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g4009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3967"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3939",
    d: "M591 566.094h7.555v10.941H591z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3947"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3941",
    d: "M596.147 566.715h1.837v2.758h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3943",
    d: "M593.86 566.715h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3945",
    d: "M591.571 566.715h1.837v2.758h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3955"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3949",
    d: "M596.147 570.185h1.837v2.759h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3951",
    d: "M593.86 570.185h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3953",
    d: "M591.571 570.185h1.837v2.759h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3963"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3957",
    d: "M596.147 573.657h1.837v2.757h-1.837z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3959",
    d: "M593.86 573.657h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3961",
    d: "M591.571 573.657h1.837v2.757h-1.837z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3997"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect3969",
    d: "M622.05 566.094h7.555v10.941h-7.555z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3977"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3971",
    d: "M627.198 566.715h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3973",
    d: "M624.909 566.715h1.836v2.758h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3975",
    d: "M622.621 566.715h1.837v2.758h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3985"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3979",
    d: "M627.198 570.185h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3981",
    d: "M624.909 570.185h1.836v2.759h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3983",
    d: "M622.621 570.185h1.837v2.759h-1.837z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3993"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3987",
    d: "M627.198 573.657h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3989",
    d: "M624.909 573.657h1.836v2.757h-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect3991",
    d: "M622.621 573.657h1.837v2.757h-1.837z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4007"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect3999",
    d: "M605.25 564.175h10.105v22.442H605.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14417",
    id: "rect4001",
    d: "M606.024 564.948h8.558v21.67h-8.558z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14418",
    id: "rect4003",
    d: "M613.858 564.948h.723v21.67h-.723z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14418",
    id: "rect4005",
    d: "M606.024 564.948h7.834v.736h-7.834z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4049"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14414",
    id: "rect4011",
    d: "M586.043 533.182h48.478v2.86h-48.478z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect4013",
    style: {
      fill: "#c6c8c8"
    },
    d: "M586.043 533.181h48.478v.662h-48.478z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4015",
    d: "M586.043 536.042h48.478v1.133h-48.478z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14416",
    id: "rect4017",
    d: "M586.043 537.175h48.478v.827h-48.478z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g4047"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4019",
    d: "M587.325 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4021",
    d: "M590.747 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4023",
    d: "M594.171 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4025",
    d: "M597.594 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4027",
    d: "M601.017 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4029",
    d: "M604.44 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4031",
    d: "M607.863 533.181h1.414v2.861h-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4033",
    d: "M611.286 533.181h1.415v2.861h-1.415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4035",
    d: "M614.709 533.181h1.416v2.861h-1.416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4037",
    d: "M618.133 533.181h1.415v2.861h-1.415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4039",
    d: "M621.556 533.181h1.416v2.861h-1.416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4041",
    d: "M624.979 533.181h1.415v2.861h-1.415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4043",
    d: "M628.402 533.181h1.415v2.861h-1.415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "rect4045",
    d: "M631.825 533.181h1.415v2.861h-1.415z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g4063"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    id: "polygon4051",
    d: "m610.282 517.752-25.005 15.43H635.288z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4061"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14417",
    id: "polygon4053",
    d: "m610.282 519.171-20.376 12.602H630.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14418",
    id: "polygon4055",
    d: "m609.026 519.948 1.256-.777 20.378 12.602h-2.471z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14418",
    d: "M604.271 531.773a4.303 4.303 0 0 1 8.567 0h1.166a5.468 5.468 0 0 0-5.449-5.059 5.47 5.47 0 0 0-5.452 5.059z",
    id: "path4057"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M614.852 531.773a5.471 5.471 0 1 0-10.942 0h1.166a4.306 4.306 0 0 1 8.61 0z",
    id: "path4059"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g4113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4077"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4067",
    d: "M605.22 586.618h10.105v10.742H605.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect4069",
    d: "M605.22 586.618h10.105v1.171H605.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect4071",
    d: "M605.22 589.304h10.105v1.171H605.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect4073",
    d: "M605.22 591.989h10.105v1.171H605.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14406",
    id: "rect4075",
    d: "M605.22 594.675h10.105v1.171H605.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4083"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M603.175 597.36v-12.581c0-.202-.222-.365-.495-.365s-.494.163-.494.365v12.581z",
    id: "path4079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M618.359 597.36v-12.581c0-.202-.222-.365-.495-.365s-.495.163-.495.365v12.581z",
    id: "path4081"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4093"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect4087",
    d: "M615.325 586.618h21.293v10.742h-21.293z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect4089",
    d: "M615.325 586.618h21.293v1.171h-21.293z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14416",
    id: "rect4091",
    d: "M615.325 587.788h21.293v.895h-21.293z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14410",
    id: "rect4095",
    d: "M583.927 586.618h21.292v10.742h-21.292z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14413",
    id: "rect4097",
    d: "M583.927 586.618h21.292v1.171h-21.292z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14416",
    id: "rect4099",
    d: "M583.927 587.788h21.292v.895h-21.292z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M603.175 597.328v-12.581c0-.202-.222-.365-.495-.365s-.495.163-.495.365v12.581z",
    id: "path4105"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M618.359 597.328v-12.581c0-.202-.221-.365-.495-.365-.272 0-.494.163-.494.365v12.581z",
    id: "path4107"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "g4309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4167"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14420",
    id: "rect4121",
    d: "M679.76 561.197h2.922v37.114h-2.922z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14420",
    id: "rect4123",
    d: "M745.222 561.197h2.921v37.114h-2.921z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4125",
    style: {
      fill: "none"
    },
    d: "M685.929 564.395h.001v10.156h-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon4127",
    style: {
      fill: "#a4a6a9"
    },
    d: "M685.93 564.395h59.292v-1.693h-62.54v1.693h3.247z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "rect4129",
    d: "M682.682 561.009h62.54v1.693h-62.54z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon4131",
    d: "M700.206 574.551h-14.277v23.76h14.277z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4133",
    d: "M727.696 574.551h14.277v23.76h-14.277z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4135",
    d: "M703.449 574.551h21.004v2.713h-21.004z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4137",
    d: "M703.449 579.191h21.004v19.12h-21.004z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "polygon4139",
    d: "M685.929 598.311V564.395h-1.927v33.916h.782z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "rect4141",
    d: "M682.685 564.395h1.316v33.916h-1.316z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "rect4143",
    d: "M743.289 564.395h1.927v33.916h-1.927z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "polygon4145",
    d: "M743.289 598.311v-33.916h-1.316V598.311h.476z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "polygon4147",
    d: "M703.449 574.551h-1.926v23.76h1.926V578.408h21.005v-1.145h-21.005z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "rect4149",
    d: "M700.206 574.551h1.317v23.76h-1.317z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "rect4151",
    d: "M725.769 574.551h1.927v23.76h-1.927z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "polygon4153",
    d: "M703.449 579.191h21.005v19.12h1.315v-23.76h-1.315v3.857h-21.005z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon4155",
    style: {
      fill: "#9e333b"
    },
    d: "M725.769 574.551h16.204v-10.156H685.93v10.156h38.524z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st14425",
    id: "polygon4159",
    d: "M698.943 598.311h1.263v-23.76H685.93v1.631h13.013z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14425",
    id: "polygon4161",
    d: "M740.709 598.311h1.264v-23.76h-14.277v1.631h13.013z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st14425",
    id: "polygon4163",
    d: "M723.19 598.311h1.264v-19.12h-21.005v1.159h19.741z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st14425",
    id: "polygon4165",
    d: "M723.19 577.263h1.264v-2.712h-21.005v1.16h19.741z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4169",
    style: {
      fill: "#c97354"
    },
    d: "M679.76 508.815h68.383v52.383H679.76z"
  }), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "g4213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4183"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect4171",
    d: "M687.704 517.158h7.127v10.319h-7.127z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4173",
    d: "M688.228 517.734h2.681v3.056h-2.681z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4175",
    d: "M691.626 517.734h2.681v3.056h-2.681z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4177",
    d: "M688.228 521.354h2.681v5.548h-2.681z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4179",
    d: "M691.626 521.354h2.681v5.548h-2.681z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect4185",
    d: "M710.389 517.158h7.126v10.319h-7.126z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4187",
    d: "M710.912 517.734h2.68v3.056h-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4189",
    d: "M714.311 517.734h2.68v3.056h-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4191",
    d: "M710.912 521.354h2.68v5.548h-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4193",
    d: "M714.311 521.354h2.68v5.548h-2.68z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect4199",
    d: "M733.073 517.158h7.127v10.319h-7.127z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4201",
    d: "M733.597 517.734h2.681v3.056h-2.681z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4203",
    d: "M736.995 517.734h2.68v3.056h-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4205",
    d: "M733.597 521.354h2.681v5.548h-2.681z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4207",
    d: "M736.995 521.354h2.68v5.548h-2.68z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "rect4215",
    style: {
      opacity: 0.5,
      fill: "#af5f46"
    },
    d: "M679.76 508.815h68.383v1.934H679.76z"
  }), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "g4255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "rect4217",
    d: "M685.93 539.569h14.123v5.119H685.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "rect4219",
    d: "M685.93 546.615h14.123v14.394H685.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "rect4221",
    d: "M727.85 546.615h14.123v14.394H727.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "rect4223",
    d: "M703.297 546.615h21.309v14.394h-21.309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "rect4225",
    d: "M703.297 539.569h21.309v5.119h-21.309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14401",
    id: "rect4227",
    d: "M727.85 539.569h14.123v5.119H727.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "rect4229",
    d: "M682.685 544.688h.001v1.146h-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "polygon4231",
    d: "M682.685 545.834v.781h.002v14.394h1.316v-21.44h-1.316v6.265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "polygon4233",
    d: "M727.85 546.615h14.123v14.394h1.317v-21.44h-1.317v6.265H727.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "polygon4235",
    d: "M703.297 545.834v.781h21.31v14.394h1.315v-21.44h-1.315v6.265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14423",
    id: "polygon4237",
    d: "M685.93 545.834v.781h14.124v14.394h1.317v-21.44h-1.317v6.265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "polygon4239",
    d: "M724.607 534.82h-41.92v4.749h1.316v21.44h1.927v-15.175h14.124v-1.146H685.93v-5.119h15.441v21.44h1.926v-15.175h21.31v-1.146h-21.31v-5.119h22.625v21.44h1.928v-15.175h14.123v-1.146H727.85v-5.119h15.44v21.44h1.927V534.82H725.922z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14428",
    id: "polygon4243",
    d: "M698.939 561.009h1.115v-14.394h-14.129v1.3h13.014z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14428",
    id: "polygon4245",
    d: "M740.863 561.009h1.116v-14.394H727.85v1.3h13.013z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14428",
    id: "polygon4247",
    d: "M698.939 544.688h1.115v-5.119h-14.129v1.3h13.014z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14428",
    id: "polygon4249",
    d: "M740.863 544.688h1.116v-5.119H727.85v1.3h13.013z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14428",
    id: "polygon4251",
    d: "M723.491 544.688h1.116v-5.119h-21.31v1.3h20.194z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14428",
    id: "polygon4253",
    d: "M723.491 561.009h1.116v-14.394h-21.31v1.3h20.194z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "g4307"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4259",
    d: "M678.886 504.769h70.132v2.012h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon4261",
    d: "M749.018 490.314v-2.647h-6.122v-.497h-57.89v.497h-6.12v2.647z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4263",
    d: "M678.886 490.69h70.132v3.143h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4265",
    d: "M678.886 501.249h70.132v3.144h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4267",
    d: "M678.886 494.21h70.132v3.143h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4269",
    d: "M685.006 484.482h57.89v2.312h-57.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "rect4271",
    d: "M678.886 497.729h70.132v3.143h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14422",
    id: "polygon4273",
    d: "M747.196 486.91h-3.153v-2.428h-1.147V487.667h6.122v19.114h-70.132V487.667h6.12v-3.185h-1.146v2.428h-6.307v-.117h-.058v19.988h-.853v2.034h74.619v-2.034h-.854v-19.988h-.057v.117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14429",
    id: "rect4275",
    d: "M685.006 486.793h57.89v.377h-57.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14429",
    id: "rect4277",
    d: "M678.886 490.314h70.132v.376h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14429",
    id: "rect4279",
    d: "M678.886 493.833h70.132v.377h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14429",
    id: "rect4281",
    d: "M678.886 497.353h70.132v.377h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14429",
    id: "rect4283",
    d: "M678.886 500.873h70.132v.376h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14429",
    id: "rect4285",
    d: "M678.886 504.393h70.132v.376h-70.132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14430",
    id: "polygon4287",
    d: "M683.86 478.225h-3.153v8.685h3.153v-2.428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14431",
    id: "polygon4289",
    d: "M677.553 486.91h3.154v-8.685h-3.154v8.568z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14432",
    id: "polygon4291",
    d: "M677.553 478.225h6.307v-.775h-6.307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14433",
    id: "polygon4293",
    d: "M679.798 475.946h-2.466v1.504H684.079v-1.504h-2.405z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect4295",
    d: "M679.798 473.178h1.876v2.767h-1.876z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14431",
    id: "polygon4297",
    d: "M744.043 484.482v2.428h3.153v-8.685h-3.153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14430",
    id: "polygon4299",
    d: "M747.196 478.225v8.685h3.154v-8.685z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14432",
    id: "polygon4301",
    d: "M744.043 478.225h6.307v-.775h-6.307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14433",
    id: "polygon4303",
    d: "M746.229 475.946h-2.406v1.504h6.748v-1.504h-2.467z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14407",
    id: "rect4305",
    d: "M746.229 473.178h1.876v2.767h-1.876z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g4325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4321"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14434",
    id: "polygon4311",
    d: "M670.361 586.532v-1.087h1.032v1.087z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14435",
    d: "M670.361 585.445h-5.343l5.154-15.126c.22-.38.236-.634.704-.634.47 0 .486.255.706.634l5.154 15.126h-5.86z",
    id: "path4313"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14436",
    id: "polygon4315",
    d: "M675.799 596.618h-9.844l-.275-7.964h10.394z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14437",
    id: "polygon4317",
    d: "m665.68 588.654-.028-.836h10.45l-.028.836H665.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14438",
    id: "polygon4319",
    d: "M676.815 587.818H664.94v-1.286h11.875z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14439",
    d: "M670.877 569.685c.47.001.486.255.706.634l5.154 15.126h-5.86z",
    id: "path4323"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "g4341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4337"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14434",
    id: "polygon4327",
    d: "M549.666 586.532v-1.087h-1.033v1.087z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14435",
    d: "M549.666 585.445h5.343l-5.154-15.126c-.22-.38-.236-.634-.705-.634s-.485.255-.706.634l-5.154 15.126h5.86z",
    id: "path4329"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14436",
    id: "polygon4331",
    d: "M544.228 596.618h9.844l.274-7.964h-10.393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14437",
    id: "polygon4333",
    d: "m554.346 588.654.028-.836h-10.449l.028.836h10.393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14438",
    id: "polygon4335",
    d: "M543.211 587.818h11.876v-1.286H543.211z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14439",
    d: "M549.149 569.685c-.469.001-.485.255-.706.634l-5.154 15.126h5.859v-15.76z",
    id: "path4339"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "g4357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4353"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14434",
    id: "polygon4343",
    d: "M248.666 586.532v-1.087h-1.033v1.087z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14435",
    d: "M248.666 585.445h5.343l-5.154-15.126c-.22-.38-.236-.634-.705-.634s-.485.255-.706.634l-5.154 15.126h5.859z",
    id: "path4345"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14436",
    id: "polygon4347",
    d: "M243.228 596.618h9.844l.274-7.964h-10.393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14437",
    id: "polygon4349",
    d: "m253.346 588.654.028-.836h-10.449l.028.836h10.393z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14438",
    id: "polygon4351",
    d: "M242.211 587.818h11.876v-1.286H242.211z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14439",
    d: "M248.149 569.685c-.469.001-.485.255-.706.634l-5.154 15.126h5.859v-15.76z",
    id: "path4355"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4415"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    d: "M530.391 450.225c-.768-.571-1.926-1.902-1.778-4.711h-1.776c.148 2.809-1.01 4.14-1.778 4.711-6.2 1.451-5.987 5.997-5.987 5.997v6.999H536.379v-6.999s.212-4.546-5.988-5.997z",
    id: "path4359"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st14441",
    id: "rect4361",
    d: "M519.334 475.112h5.283v5.252h-5.283z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    id: "rect4363",
    d: "M524.617 475.112h5.543v5.252h-5.543z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st14442",
    id: "rect4365",
    d: "M530.16 475.112h5.543v5.252h-5.543z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st14441",
    id: "rect4367",
    d: "M516.876 463.222h6.871v1.677h-6.871z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    id: "rect4369",
    d: "M523.747 463.222h7.207v1.677h-7.207z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st14442",
    id: "rect4371",
    d: "M530.954 463.222h7.208v1.677h-7.208z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4373",
    style: {
      fill: "#a77a4f"
    },
    d: "M519.334 464.899h7.987v10.213h-7.987z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st14444",
    id: "polygon4375",
    d: "M535.7 475.112v-10.213H527.321v10.213h.391z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "g4383"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4379",
    d: "M521.074 467.234h4.139v6.711h-4.139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14445",
    id: "rect4381",
    d: "M521.074 467.234h.718v6.711h-.718z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "g4389"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14399",
    id: "rect4385",
    d: "M529.195 467.234h4.631v6.711h-4.631z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14445",
    id: "rect4387",
    d: "M533.036 467.234h.718v6.711h-.718z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "g4393"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14441",
    d: "M522.038 463.222v-7.962c.018-2.824 1.965-4.709 1.965-4.709s.09-.034.231-.106c-5.359 1.641-5.163 5.778-5.163 5.778v6.999z",
    id: "path4391"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "g4397"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14442",
    d: "M533.411 463.222v-7.962c-.017-2.824-1.964-4.709-1.964-4.709s-.09-.034-.231-.106c5.359 1.641 5.164 5.778 5.164 5.778v6.999z",
    id: "path4395"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "polygon4399",
    style: {
      opacity: 0.3,
      fill: "#928a7b"
    },
    d: "M536.379 461.909h-17.307v1.313H536.379z"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    id: "polygon4401",
    d: "M535.7 464.899h-16.362v1.313H535.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4409",
    style: {
      opacity: 0.3
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    d: "M519.255 454.956a5.397 5.397 0 0 0-.103.438h17.146a5.007 5.007 0 0 0-.103-.438z",
    id: "path4403"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    id: "rect4405",
    d: "M519.072 458.48h17.308v.439h-17.308z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    d: "M534.365 452.108h-13.28a6.565 6.565 0 0 0-.454.438h14.188a6.565 6.565 0 0 0-.454-.438z",
    id: "path4407"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M531.825 440.08a.703.703 0 0 0-.65.437h-3.225v-3.304a.663.663 0 1 0-.529 0v3.304h-3.225a.7.7 0 1 0 0 .528h3.226v4.469h.528v-4.469h3.225a.704.704 0 0 0 1.353-.264.702.702 0 0 0-.703-.701z",
    id: "path4411",
    style: {
      fill: "#726658"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    d: "M529.067 445.474a1.343 1.343 0 1 1-2.686 0 1.343 1.343 0 0 1 2.686 0z",
    id: "path4413"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    id: "rect4417",
    d: "M511.421 566.348h32.195v21.536h-32.195z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st14417",
    id: "polygon4419",
    d: "M541.839 512.76h-28.64l-2.348-1.514h33.335z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st14449",
    id: "rect4421",
    d: "M510.851 509.642h33.335v1.604h-33.335z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4501"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st14450",
    id: "rect4423",
    d: "M513.26 487.439h28.517v22.203H513.26z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st14444",
    id: "rect4425",
    d: "M513.26 487.439h3.684v22.203h-3.684z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st14444",
    id: "rect4427",
    d: "M538.093 487.439h3.684v22.203h-3.684z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    id: "rect4429",
    d: "M537.514 487.439h.579v22.203h-.579z"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "g4437"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    d: "M527.518 507.635c-4.622 0-8.469-3.31-9.305-7.688h-.564a9.476 9.476 0 0 0 18.12 2.871 9.47 9.47 0 0 1-8.251 4.817z",
    id: "path4431"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    d: "M518.829 494.379a9.42 9.42 0 0 0-1.171 3.653h.388a9.448 9.448 0 0 1 .783-3.653z",
    id: "path4433"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14451",
    d: "M541.777 499.947v-1.915h-4.787a9.476 9.476 0 0 0-18.162-3.653 9.43 9.43 0 0 0-.783 3.653h-4.786v1.915h4.953c.836 4.379 4.683 7.688 9.305 7.688a9.471 9.471 0 0 0 9.306-7.688z",
    id: "path4435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4451"
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "g4447"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14451",
    id: "polygon4439",
    d: "m532.798 480.363 7.336 5.577h4.417v-5.577z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14451",
    id: "polygon4441",
    d: "M522.239 480.363h-11.752v5.577h4.416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14449",
    d: "m532.798 480.363-5.28-4.012-5.279 4.012-7.336 5.577h-4.416v1.499H544.55v-1.499h-4.416zm2.081 5.577h-18.003l10.643-8.089 10.643 8.089z",
    id: "path4443"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14417",
    id: "polygon4445",
    d: "M527.519 485.94H538.162l-10.643-8.09-10.643 8.09h10.168z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "polygon4449",
    style: {
      fill: "#a54a2a"
    },
    d: "M517.91 485.94h-1.034l10.643-8.09.517.394z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    id: "polygon4453",
    d: "M541.777 487.439H513.26v1.314h28.517z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "g4499"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    d: "M535.7 498.159a8.182 8.182 0 1 1-16.363-.001 8.182 8.182 0 0 1 16.363.001z",
    id: "path4455"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4461"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14453",
    id: "rect4457",
    d: "M527.301 490.871h.604v.93h-.604z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14453",
    id: "rect4459",
    d: "M527.301 504.274h.604v.93h-.604z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4467"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14453",
    id: "rect4463",
    d: "M520.437 497.734h.93v.605h-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14453",
    id: "rect4465",
    d: "M533.841 497.734h.929v.605h-.929z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4473"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-57.575 524.05 503.7)",
    className: "st14453",
    id: "rect4469",
    d: "M523.55 503.395h.93V504h-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-57.604 531.172 492.355)",
    className: "st14453",
    id: "rect4471",
    d: "M530.727 492.075h.931v.604h-.931z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4479"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-30.243 521.841 501.395)",
    className: "st14453",
    id: "rect4475",
    d: "M521.346 501.106h.93v.604h-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-30.117 533.485 494.691)",
    className: "st14453",
    id: "rect4477",
    d: "M532.93 494.364h.93v.604h-.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4487"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-32.424 531.21 503.696)",
    className: "st14453",
    id: "rect4483",
    d: "M530.889 503.232h.605v.93h-.605z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-32.379 524.05 492.402)",
    className: "st14453",
    id: "rect4485",
    d: "M523.712 491.912h.604v.93h-.604z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4493"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-59.755 533.388 501.392)",
    className: "st14453",
    id: "rect4489",
    d: "M533.093 500.942h.604v.93h-.604z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-59.853 521.816 494.684)",
    className: "st14453",
    id: "rect4491",
    d: "M521.508 494.202h.604v.93h-.604z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14453",
    d: "m532.406 501.036-4.287-2.848c.001-.009.003-.018.003-.029a.597.597 0 0 0-.239-.477l1.55-2.535-.376-.23-1.62 2.647a.601.601 0 0 0 .081 1.199.601.601 0 0 0 .416-.168l4.227 2.808z",
    id: "path4497"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "g4507"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14440",
    id: "rect4503",
    d: "M509.65 590h35.737v15.974H509.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14442",
    id: "polygon4505",
    d: "M545.387 590H509.65l1.771-2.335h32.195z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M542.782 566.348h-.438v2.352h-5.58v-2.352h-.438v2.352h-5.58v-2.352h-.437v2.352h-5.581v-2.352h-.437v2.352h-5.581v-2.352h-.438v2.352h-5.58v-2.352h-.437v2.352h-.834v.439h3.719v3.354h-3.719v.439h.834v3.356h-.834v.436h3.719v3.355h-3.719v.439h.834v3.356h-.834v.436h3.719v3.356h-3.719 32.195-3.528v-3.356h3.528v-.436h-.834v-3.356h.834v-.439h-3.528v-3.355h3.528v-.436h-.834v-3.356h.834v-.439h-3.528v-3.354h3.528v-.439h-.834zm-8.821 2.79h5.69v3.354h-5.69zm-12.692 7.585v3.355h-5.69v-3.355zm-2.558-.436v-3.356h5.581v3.356zm0 4.23h5.581v3.356h-5.581zm2.996-.439v-3.355h5.689v3.355zm3.022-3.791v-3.356h5.581v3.356zm0 4.23h5.581v3.356h-5.581zm3.105-.439v-3.355h5.689v3.355zm2.913.439h5.58v3.356h-5.58zm3.214-.439v-3.355h5.69v3.355zm2.366-3.791h-5.58v-3.356h5.58zm-8.493-7.149h5.689v3.354h-5.689zm-6.127 0h5.689v3.354h-5.689zm-6.128 0h5.69v3.354h-5.69zm-2.887 7.149v-3.356h5.58v3.356zm0 7.586v-3.356h5.58v3.356zm8.577 3.792h-5.69v-3.356h5.69zm6.127 0h-5.689v-3.356h5.689zm6.127 0h-5.689v-3.356h5.689zm6.128 0h-5.69v-3.356h5.69zm2.693-7.148v3.356h-5.58v-3.356zm0-7.586v3.356h-5.58v-3.356z",
    id: "path4509",
    style: {
      fill: "#7f7d7f"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    id: "polygon4511",
    d: "m511.452 566.348-.051 1.312H543.638l-.052-1.312z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "g4517"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14417",
    id: "polygon4513",
    d: "M543.616 566.348h-32.195l-1.445-1.515h35.086z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14449",
    id: "rect4515",
    d: "M509.976 563.229h35.086v1.604h-35.086z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4529"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14444",
    id: "polygon4519",
    d: "m513.201 512.76-1.764 50.469h32.164l-1.765-50.469z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st14450",
    id: "polygon4521",
    d: "M518.369 563.229h18.951v-3.291h2.478v-3.344h-2.478v-4.458h2.224v-3.355h-2.224v-4.232h2.224v-3.355h-2.224v-4.449h2.224v-3.356h-2.224v-4.231h2.224v-3.355h-2.224v-4.231h2.224v-3.355h-2.674v.006h-18.286v-.006h-2.674v3.355h2.459v4.231h-2.459v3.355h2.459v4.231h-2.459v3.356h2.459v4.449h-2.459v3.355h2.459v4.232h-2.459v3.355h2.459v4.458h-2.206v3.344h2.206z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st14451",
    id: "polygon4523",
    d: "M513.011 518.216h29.017l-.032-.9h-28.954z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st14447",
    id: "polygon4525",
    d: "m513.201 512.76-.046 1.313h28.728l-.047-1.313z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M520.173 563.229h.438v-2.851h5.58v2.851h.439v-2.851h5.579v2.851h.438v-2.851h4.673v-.439h-1.457v-3.354h1.457v-.438h-4.673v-3.574h4.673v-.437h-1.457v-3.355h1.457v-.439h-4.673v-3.355h4.673v-.437h-1.457v-3.356h1.457v-.437h-4.673v-3.574h4.673v-.437h-1.457v-3.356h1.457v-.437h-4.673v-3.356h4.673v-.438h-1.457v-3.355h1.457v-.438h-4.673v-3.354h4.673v-.439h-1.457v-3.35h-.438v3.35h-5.69v-3.35h-.437v3.35h-5.691v-3.35h-.437v3.35h-4.802v.439h1.805v3.354h-1.805v.438h4.802v3.355h-4.802v.438h1.805v3.356h-1.805v.437h4.802v3.356h-4.802v.437h1.805v3.574h-1.805v.437h4.802v3.356h-4.802v.437h1.805v3.355h-1.805v.439h4.802v3.355h-4.802v.437h1.805v3.574h-1.805v.438h4.802v3.354h-4.802v.439h1.805zm9.125-3.29h-5.691v-3.354h5.691zm-2.668-30.344h5.579v3.356h-5.579zm-3.023-.437v-3.355h5.691v3.355zm5.691 4.231v3.356h-5.691v-3.356zm-2.668 3.793h5.579v3.574h-5.579zm2.668 4.012v3.356h-5.691v-3.356zm-2.668 3.793h5.579v3.355h-5.579zm2.668 3.794v3.355h-5.691v-3.355zm-2.668 3.792h5.579v3.574h-5.579zm8.794 4.012v3.354h-5.69v-3.354zm0-7.804v3.355h-5.69v-3.355zm0-7.587v3.356h-5.69v-3.356zm0-7.805v3.356h-5.69v-3.356zm0-7.586v3.355h-5.69v-3.355zm-8.794-3.792h5.579v3.354h-5.579zm-6.019 3.354v-3.354h5.58v3.354zm0 7.587v-3.356h5.58v3.356zm0 7.804v-3.574h5.58v3.574zm0 7.586v-3.355h5.58v3.355zm0 7.805v-3.574h5.58v3.574z",
    id: "path4527",
    style: {
      fill: "#b2825d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4545"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st14456",
    d: "M234.908 574.591c-.284 0-.562-.029-.833-.074v20.869h1.682v-20.872c-.278.048-.56.077-.849.077z",
    id: "path4533"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st14456",
    id: "rect4535",
    d: "M233.143 596.534h3.53v19.885h-3.53z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st14403",
    id: "polygon4537",
    d: "M234.074 595.387h-.014l-.917 1.147h3.53l-.917-1.147z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M235.756 574.515a5.09 5.09 0 0 0-.848-10.11 5.09 5.09 0 0 0-.834 10.112c.272.044.549.074.833.074.29 0 .572-.029.849-.076zm-5.292-5.017a4.443 4.443 0 1 1 8.887 0 4.443 4.443 0 0 1-8.887 0z",
    id: "path4539"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.351 569.498a4.443 4.443 0 1 0-8.887 0 4.443 4.443 0 0 0 8.887 0zm-7.434.857v-1.715h5.981v1.715z",
    id: "path4541",
    style: {
      fill: "#ba162b"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st14396",
    id: "rect4543",
    d: "M231.917 568.64h5.981v1.715h-5.981z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001TotalBuilding);
export default __webpack_public_path__ + "static/media/001-TotalBuilding.29d8fcda42ae2f3426d233cdba50ae1f.svg";
export { ForwardRef as ReactComponent };